import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/material/examples/no-conversation-history/no-conversation-history.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
